/**
 * Hide unavailable variant swatches completely (no grey/strike-through).
 * Only swatches with data-option-available="true" are shown.
 */
function hideUnavailableSwatches() {
  const swatches = document.querySelectorAll(
    '.variant-option__swatches-inline label'
  );

  swatches.forEach(label => {
    const input = label.querySelector('input');

    if (!input) return;

    const available = input.dataset.optionAvailable === 'true';

    label.style.display = available ? '' : 'none';
  });
}

// Run on page load (initial state and when landing with ?variant=)
document.addEventListener('DOMContentLoaded', hideUnavailableSwatches);

// Run after theme finishes updating variant DOM (fetch + morph)
document.addEventListener('variant:update', hideUnavailableSwatches);

// Fallback when variant option is clicked (covers full-page morph where variant:update is not dispatched)
document.addEventListener('change', (e) => {
  if (e.target.matches('.variant-option__button-label input')) {
    setTimeout(hideUnavailableSwatches, 400);
  }
});
